export const en = {
  $vuetify: {
    // C
    close: 'Close',
    chooseOption: 'Choose an option',
    collectionTitle: 'Product version',

    // P
    projectHasBeenSaved: 'The project has been saved',
    projectCodeSummary: 'Use the following code to reopen it and continue it later',

    // Q
    qrcodeSummary: 'Scan the QR code with your smartphone to see the product in augmented reality',

    // S
    seeInAR: 'See in AR',
  },
}
